<template>
	<div>
		<div v-if="valid">
			<div class="container">
				<div class="connection__stream">
					<div>
						<h3>Connection Stream (LIVE)</h3>
					</div>
					<div>
						<div @click="logOut()">Log Out</div>
					</div>
				</div>
				<div class="connection__stream--body">
					<div 
						v-for="(obj, index) in connectionData"
						:key="index"
						class="connection__stream--body-box"
						:class="`connection__stream--body-box--${obj.author}`"
					>
						<div class="author">{{ obj.author }}</div>
						<div class="message">{{ obj.message }}</div>
						<div class="date">{{ obj.added_on }}</div>
					</div>
				</div>

				<div class="connection__stream--post">
					<textarea placeholder="Enter your message" class="text_box"></textarea>
					<div class="connection__stream--post--button" @click="sendConnection()">{{sendText}}</div>
				</div>
			</div>
		</div>
		<div 
			v-else
			class="connection"
		>
			<div class="connection__header">
				<h1>Lobster's Connection</h1>
				<small>Please enter the passcode</small>
			</div>
			<div class="connection__indicator">
				<div
					v-for="(digit, index) in showCodeEntered"
					:key="index"
					class="connection__indicator--box"
					:class="{ 'clicked' : (index < enteredCode.length) }"
					@click="digitPressed(digit)"
				>
				</div>
			</div>
			<div class="connection__error--div">
				<div class="connection__error" v-if="incorrect">Invalid Pin, Please try again</div>
			</div>
			<div class="connection__passcode">
				<div
					v-for="(row, index) in passcodeDigits"
					:key="index"
					class="connection__keypad--row"
				>
					<div
						v-for="(digit, subIndex) in row"
						:key="subIndex"
						class="connection__keypad--digit"
						:class="{ 'clicked' : (digitClicked === digit) }"
						@click="digitPressed(digit)"
					>
						{{ digit }}
					</div>
				</div>
			</div>

			<div class="connection__clear" >
				<div 
					v-if="enteredCode.length > 0"
					@click="logOut()"
				>Clear</div>
				<div 
					v-if="enteredCode.length > 0"
					@click="deleteValue()"
				>Delete</div>
			</div>

			<div class="connection__footer">
				<router-link
					to="/"
					tag="div"
				>
					Back to home
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';

	export default {
		data() {
			return {
				passcodeDigits: [[1, 2, 3], [4, 5, 6], [7, 8, 9], [0]],
				code: [1, 5, 0, 3],
				enteredCode: [],
				digitClicked: -1,
				showCodeEntered: [1, 2, 3, 4],
				incorrect: false,
				valid: false,
				connectionData: [],
				sendText: 'Send',
				username: 'lubosh_luna',
				password: '268eadgbe373'
			}
		},
		mounted() {
			$.ajax({
				type: "GET",
				"crossDomain": true,
				url: 'http://api.lobsterstory.com/api/sendEmail?message=Landed',
			});
		},
		methods: {
			digitPressed(digit) {
				this.incorrect = false;
				this.valid = false;

				this.digitClicked = digit;
				setTimeout(() => {
					this.digitClicked = -1;
				}, 200)

				this.enteredCode.push(digit);
				if (this.enteredCode.length === this.code.length) {
					this.validateCode();
				} else  if (this.enteredCode.length > this.code.length) {
					this.enteredCode = [];
				}
			},
			validateCode() {
				let process = true;
				for (let i = 0; i < this.code.length; i++) {
					process = process && this.code[i] === this.enteredCode[i];
				}
				
				
				if (process) {
					$.ajax({
						type: "GET",
						"crossDomain": true,
						url: 'http://api.lobsterstory.com/api/sendEmail?message=Login Successful',
					});
					this.valid = true;
					this.connectionDataFn();
				} else {
					setTimeout(() => {
						this.enteredCode = [];
						this.incorrect = true;
					}, 250);
				}
			},
			logOut() {
				this.valid = false;
				this.enteredCode = [];
			},
			deleteValue() {
				this.enteredCode.pop();
			},
			connectionDataFn() {
				$.ajax({
					type: "POST",
					url: 'http://api.lobsterstory.com/api/getFeed/',
					crossDomain: true,
					cache: false,
					data: {
						username: this.username,
						password: this.password
					},
					success: (result) => {
						const json = JSON.parse(result);
						if (json.status === 200) {
							this.connectionData = json.data.reverse();
						}
					},
				});
			},
			sendConnection() {
				this.sendText = 'Sending...';
				const textbox = document.querySelector('.text_box');
				let message = textbox.value;

				if (!message) {
					this.sendText = 'Send';
					return;
				}

				let author = 'Luna';
				const tmp = message.split('###268###');

				if (tmp.length > 1) {
					const [msg, realMessage] = tmp;

					if (msg === 'SD') {
						author = 'Lubosh';
						message = realMessage;
					}
				}

				$.ajax({
					type: "POST",
					url: 'http://api.lobsterstory.com/api/addFeed/',
					crossDomain: true,
					data: {
						username: this.username,
						password: this.password,
						author, 
						message,
					},
					success: (result) => {
						const json = JSON.parse(result);
						if (json.status === 200) {
							this.sendText = 'Send';
							textbox.value = '';

							this.connectionDataFn();
						}
					},
				});
				
			}
		}
	};
</script>

<style lang="scss">
	body {
		&[data-screen="connection"] {
			main.content {
				padding: 0;
			}
		}
	}
</style>

<style lang="scss" scoped>
	.connection {
		display: flex;
		width: 100vw;
		height: 100vh;
		flex-direction: column;

		align-content: center;
		align-items: center;
		justify-content: center;

		&__header {
			padding: 0.5em;
			text-align: center;

			h1 {
				margin: 0 0 0.5em 0;
				font-size: 1.4em;
			}
		}

		&__passcode {
			margin: 1em 0;
		}

		&__keypad {
			&--row {
				display: block;
				text-align: center;
			}

			&--digit {
				width: 50px;
				height: 50px;
				border: 2px solid #ffffff;
				border-radius: 100%;
				display: inline-flex;
				align-content: center;
				align-items: center;
				justify-content: center;
				flex-direction: row;
				margin: 0.5em 1em 0.5em 0;
				cursor: pointer;
				-webkit-tap-highlight-color: transparent;

				&:last-child {
					margin-right: 0;
				}

				&.clicked {
					background: rgba(#ffffff, 0.3);
					transition: all 0.1s ease;
				}
			}
		}

		&__indicator {
			margin: 1em 0 0 0;

			&--box {
				width: 10px;
				height: 10px;
				border: 1px solid #fff;
				border-radius: 50%;
				display: inline-flex;
				margin: 0 0.25em 0;

				&.clicked {
					background: rgba(#ffffff, 0.7);
					transition: all 0.1s ease;
				}
			}
		}

		&__error {
			color: #cccccc;
			font-weight: bold;
			font-size: 12px;
			margin-top: 1em;

			&--div {
				min-height: 30px;
			}
		}

		&__clear {
			display: flex;
			min-height: 80px;

			div {
				display: flex;
				flex: 1;
				margin: 0 3em 3em 3em;
				font-size: 14px;
			}
		}

		&__footer {
			font-size: 0.8em;
			color: $secondary;
		}

		&__stream {
			display: flex;
			width: 100%;
			flex: 1;
			align-content: center;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid rgba(#ccc, 0.8);

			& > div {
				flex: 1;
				padding: {
					top: 1em;
					bottom: 1em;
				}
				font-size: 0.9em;
				align-content: center;
				justify-content: center;
				align-items: center;

				h3 {
					margin: 0;
				}

				&:last-child {
					text-align: right;
					font-size: 14px;
				}
			}

			&--body {
				margin-top: 2em;

				&-box {
					margin: 1em 0;
					width: 90%;
					font-size: 14px;

					.message {
						margin: 0.25em 0;
						background: $_copy;
						border-radius: 3px;
						padding: 5px;
						color: #000;
						font-weight: 600;
						width: auto;
						display: inline-block;
					}

					&--Luna {
						text-align: right;
						margin-left: auto;

						.message {
							background: $secondary;
						}
					}

					.author {
						font-size: 12px;
						font-weight: 600;
					}

					.date {
						font-size: 10px;
					}
				}
			}

			&--post {
				margin: 3em 0;

				textarea {
					resize: none;
					border: none;
					width: calc(100% - 20px);
					height: 80px;
					border-radius: 6px;
					padding: 10px;
					font-size: 16px;
				}

				&--button {
					background: $_copy-alt;
					max-width: 70px;
					text-align: center;
					padding: 5px 10px;
					border-radius: 6px;
					margin-left: auto;
				}
			}
		}
	}
</style>

